export enum ContentTypes {
  MOVIE = "movie",
  TV_SERIES = "tv_series",
  LIVE_TV = "live_tv",
  PODCAST = "podcast",
  PODCAST_EPISODE = "podcast_episode",
  RADIO = "radio",
  SONG = "song",
  PPV = "ppv",
  VIDEO = "video",
  PLAYLIST = "playlist",
  PUBLICATION_VIDEO = "publication_video",
}
